import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import bemCnFast from '@webteam/bem-cn-fast';
import { useTheme } from '@rescui/ui-contexts';
import localNames from '../index.pcss.js';

var bemCn = bemCnFast('wt-list-divider', localNames);
function Divider(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      themeProps = _ref.theme,
      restProps = _objectWithoutProperties(_ref, ["className", "theme"]);

  var theme = useTheme(themeProps);
  return React.createElement("hr", _extends({
    className: cn(bemCn({
      theme: theme
    }), className)
  }, restProps));
}
Divider.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark'])
};

export { Divider };
